import { Checkbox } from 'antd';
import { StyledStack } from 'app/components/Stack';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import {
  GET_LIST_PAYMENT_METHOD,
  useCatalogSlice,
} from 'app/pages/Catalog/slice';
import * as _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { CommonText } from '../styled';
const TicketFormComponent = ({ onChangeMethod, defaultValue }) => {
  useCatalogSlice();
  const dispatch = useDispatch();
  const translations = useSelector(selectTranslations);
  const listTicketForm = useSelector(
    (state: any) => state?.catalog?.listTicketForm,
  );
  const [ticketForm, setTicketForm] = useState();

  const onChangeMethodCallback = useCallback(
    value => {
      onChangeMethod && onChangeMethod(value);
    },
    [onChangeMethod],
  );

  const handleChangeTicketForm = e => {
    const value = e.target.value;
    setTicketForm(value);
    onChangeMethodCallback(value);
  };

  useEffect(() => {
    if (ticketForm) return;
    const initValue =
      listTicketForm?.find(i => _.isEmpty(i?.code) || i.id === 27963)?.id ??
      listTicketForm?.[0]?.id;

    setTicketForm(defaultValue || initValue);
    onChangeMethodCallback(defaultValue || initValue);
  }, [
    onChangeMethod,
    listTicketForm,
    ticketForm,
    onChangeMethodCallback,
    defaultValue,
  ]);

  useEffect(() => {
    if (listTicketForm?.length > 0) return;
    dispatch(
      GET_LIST_PAYMENT_METHOD({
        ticketType: sessionStorage.getItem('ticketType'),
      }),
    );
  }, [dispatch, listTicketForm?.length]);

  return (
    <StyledStack direction={'column'} rowGap={'16px'}>
      <CommonText style={{ fontSize: 16 }}>
        {translations?.['b2b.txt.ticket-form']}
      </CommonText>
      {listTicketForm?.length > 0 && (
        <StyledStack>
          {listTicketForm.map((i, index) => {
            const value = i?.id;
            return (
              <StyledCheckbox
                style={{ borderRadius: '50%', marginTop: -5, width: '50%' }}
                key={index}
                checked={value === ticketForm}
                value={value}
                onChange={handleChangeTicketForm}
              >
                {i?.name || i?.code}
              </StyledCheckbox>
            );
          })}
        </StyledStack>
      )}
    </StyledStack>
  );
};

export default TicketFormComponent;

export const StyledCheckbox = styled(Checkbox)`
  &.ant-checkbox-wrapper {
    width: max-content;
    .ant-checkbox-inner {
      border-radius: 50%;
    }
    .ant-checkbox {
      & + span {
        color: #000000;
      }
    }
    .ant-checkbox-checked {
      &:after {
        border-radius: 50%;
      }
    }
  }
`;
